import React, {useEffect, useRef, useState} from 'react'

import {CheckCircleIcon, CheckIcon, XCircleIcon} from '@heroicons/react/solid'
import {Link, useNavigate} from "react-router-dom";
import sdk from "scoutli-sdk";

const tabs = [
    {id: 0, name: 'Profile'},
    {id: 1, name: 'Subscription'},
    {id: 2, name: 'Preferences'}
]

const tiers = [
    {
        name: 'Hobby',
        href: '#',
        price: 0,
        description: 'All the basics for starting a new business',
        features: [
            'Potenti felis, in cras at at ligula nunc.',
            'Orci neque eget pellentesque.'
        ],
    },
    {
        name: 'Freelancer',
        href: '#',
        price: 9,
        description: 'All the basics for starting a new business',
        features: [
            'Potenti felis, in cras at at ligula nunc.',
            'Orci neque eget pellentesque.',
            'Orci neque eget pellentesque.'
        ]
    },
    {
        name: 'Startup',
        href: '#',
        price: 19,
        description: 'All the basics for starting a new business',
        features: [
            'Potenti felis, in cras at at ligula nunc. ',
            'Orci neque eget pellentesque.',
            'Donec mauris sit in eu tincidunt etiam.',
            'Donec mauris sit in eu tincidunt etiam.'
        ],
    },
    {
        name: 'Enterprise',
        href: '#',
        price: 29,
        description: 'All the basics for starting a new business',
        features: [
            'Potenti felis, in cras at at ligula nunc. ',
            'Orci neque eget pellentesque.',
            'Donec mauris sit in eu tincidunt etiam.',
            'Faucibus volutpat magna.',
            'Faucibus volutpat magna.'
        ],
    },
    {
        name: 'Ultimate',
        href: '#',
        price: 39,
        description: 'All the basics for starting a new business',
        features: [
            'Potenti felis, in cras at at ligula nunc. ',
            'Orci neque eget pellentesque.',
            'Donec mauris sit in eu tincidunt etiam.',
            'Faucibus volutpat magna.',
            'Id sed tellus in varius quisque.',
            'Risus egestas faucibus.',
            'Risus cursus ullamcorper.',
        ],
    },
]

function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
}

export default function Settings() {
    const [type, setType] = useState(0)
    const [user, setUser] = useState(null)
    const [loading, setLoading] = useState(true)
    const [alert, setAlert] = useState(false)
    const [alertOpen, setAlertOpen] = useState(false)
    const [canSave, setCanSave] = useState(false)
    const [canChange, setCanChange] = useState(true)
    const [picture, setPicture] = useState(0)
    const [biographyLength, setBiographyLength] = useState(0)

    const inputFile = useRef(null)

    const name = useRef("")
    const biography = useRef(null)

    const navigate = useNavigate()

    const accessToken = localStorage.getItem("accessToken")

    useEffect(() => {
        sdk.user(accessToken).get.userData().then(async data => {
            setUser(data)

            setBiographyLength(data.biography.length)
        }).catch(() => {
            return navigate("/")
        }).finally(async () => {
            setLoading(false)

            setPicture(await sdk.user(accessToken).get.profilePicture())
        });
    }, [])

    if (loading) return (
        <>
        </>
    );

    const getBiographyColor = () => {
        if (biographyLength < 100){
            return "text-gray-500";
        }

        if (biographyLength >= 100 && biographyLength < 125){
            return "text-yellow-300";
        }

        if (biographyLength >= 125 && biographyLength < 150){
            return "text-yellow-400";
        }

        if (biographyLength >= 150 && biographyLength < 200){
            return "text-yellow-500";
        }

        if (biographyLength >= 200 && biographyLength < 225){
            return "text-red-300";
        }

        if (biographyLength >= 225 && biographyLength < 250){
            return "text-red-400";
        }

        if (biographyLength >= 250 && biographyLength < 300){
            return "text-red-500";
        }

        if (biographyLength === 300){
            return "text-red-600";
        }
    }

    return (
        <div className="flex flex-col gap-y-6 h-full">
            <div
                className={`fixed bottom-5 z-10 left-5 sm:left-auto right-5 transition-all ${alertOpen !== false ? "visible opacity-100" : "invisible opacity-0"}`}>
                <div
                    className={`flex items-center rounded-md ${alert.type ? "bg-green-50" : "bg-red-50"} p-3 max-w-max`}>
                    {alert.type && (
                        <CheckCircleIcon className="h-5 w-5 text-green-400" aria-hidden="true"/>
                    )}

                    {!alert.type && (
                        <XCircleIcon className="h-5 w-5 text-red-400" aria-hidden="true"/>
                    )}

                    <div className="ml-3">
                        {alert.type && (
                            <h3 className="text-sm font-medium text-green-800 mb-0">{alert.text}</h3>
                        )}

                        {!alert.type && (
                            <h3 className="text-sm font-medium text-red-800 mb-0">{alert.text}</h3>
                        )}
                    </div>
                </div>
            </div>

            <div className="sm:hidden">
                <label htmlFor="tabs" className="sr-only">
                    Select a tab
                </label>

                <select
                    id="tabs"
                    name="tabs"
                    className="w-full pl-3 pr-10 py-2 text-base border-gray-300 transition-colors focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md"
                    defaultValue={tabs.find((tab) => tab.id === type).name}
                    onChange={e => {
                        setType(tabs.find(tab => tab.name === e.target.value).id ?? 0)
                    }}
                >
                    {tabs.map((tab) => (
                        <option key={tab.name}>{tab.name}</option>
                    ))}
                </select>
            </div>

            <div className="hidden sm:block">
                <div className="border-b border-gray-200">
                    <nav className="-mb-px flex justify-between" aria-label="Tabs">
                        <div className="flex gap-x-8 items-center justify-center">
                            {tabs.map((tab) => (
                                <a
                                    key={tab.name}
                                    className={classNames(
                                        tab.id === type
                                            ? 'border-indigo-500 text-indigo-600'
                                            : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300',
                                        'whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm cursor-pointer'
                                    )}
                                    onClick={() => {
                                        setType(tab.id)
                                    }}
                                    aria-current={tab.id === type ? 'page' : undefined}
                                >
                                    {tab.name}
                                </a>
                            ))}
                        </div>

                    </nav>
                </div>
            </div>

            {type === 0 && (
                <div className="pt-0 sm:pt-8">
                    <div className="md:grid md:grid-cols-3 md:gap-6">
                        <div className="md:col-span-1">
                            <div className="px-4 sm:px-0">
                                <h3 className="text-lg font-medium leading-6 text-gray-900">Profile</h3>
                                <p className="mt-1 text-sm text-gray-600">
                                    This information will be displayed publicly, so be careful what you share.
                                </p>
                            </div>
                        </div>
                        <div className="md:col-span-2 mt-8 sm:mt-0">
                            <form action="#" method="POST" onSubmit={event => {
                                event.preventDefault()

                                sdk.user(accessToken).set.userData({
                                    name: name.current.value,
                                    biography: biography.current.value
                                }).then(response => {
                                    setAlert({
                                        type: true,
                                        text: response.en
                                    })

                                    setAlertOpen(true)

                                    setCanSave(false)

                                    sdk.user(accessToken).get.userData().then(data => {
                                        setUser(data)
                                    }).catch(() => {
                                        return navigate("/")
                                    }).finally(() => {
                                        setLoading(false)
                                    });
                                }).catch(response => {
                                    if (response == -1) {
                                        return navigate("/")
                                    }

                                    setAlert({
                                        type: false,
                                        text: response.en
                                    })

                                    setAlertOpen(true)
                                }).finally(() => {
                                    setTimeout(() => {
                                        setAlertOpen(false)
                                    }, 3000)
                                })
                            }}>
                                <div className="sm:rounded-md sm:overflow-hidden">
                                    <div className="px-4 bg-white space-y-6">
                                        <div className="grid grid-cols-3 gap-6">
                                            <div className="col-span-3 sm:col-span-2">
                                                <label className="block text-sm font-medium text-gray-700">Profile Picture</label>

                                                <div className="mt-2 flex items-center">
                                                          <span
                                                              className="inline-block h-12 w-12 rounded-full overflow-hidden bg-gray-100">
                                                            <img
                                                                id="oldPicture"
                                                                src={picture === 0 ? "" : (picture == null ? "" : picture)}
                                                            />
                                                          </span>
                                                    <input
                                                        type="file"
                                                        id="file"
                                                        ref={inputFile}
                                                        style={{display: "none"}}
                                                        accept=".jpg, .png, .jpeg"
                                                        onChange={async (event) => {
                                                            event.stopPropagation();
                                                            event.preventDefault();

                                                            const a = await event.target.files[0].arrayBuffer()

                                                            let binary = "";
                                                            let bytes = new Uint8Array(a);
                                                            let len = bytes.byteLength;

                                                            for (let i = 0; i < len; i++) {
                                                                binary += String.fromCharCode(bytes[i]);
                                                            }

                                                            setCanChange(false)

                                                            await sdk.user(accessToken).set.profilePicture(btoa(binary)).then(response => {
                                                                setAlert({
                                                                    type: true,
                                                                    text: response.en
                                                                })

                                                                let imageUrl = `data:image/jpeg;base64,${btoa(binary)}`;

                                                                let oldPicture = document.getElementById("oldPicture");

                                                                if (oldPicture) {
                                                                    oldPicture.src = imageUrl;
                                                                }

                                                                let navPicture = document.getElementById("navPicture");

                                                                if (navPicture) {
                                                                    navPicture.src = imageUrl;
                                                                }

                                                                setAlertOpen(true)
                                                            }).catch(response => {
                                                                setAlert({
                                                                    type: false,
                                                                    text: response.en
                                                                })

                                                                setAlertOpen(true)
                                                            }).finally(() => {
                                                                setTimeout(() => {
                                                                    setAlertOpen(false)
                                                                }, 3000)

                                                                setCanChange(true)
                                                            })
                                                        }}
                                                    />
                                                    <button
                                                        disabled={!canChange}
                                                        type="button"
                                                        onClick={(event) => {
                                                            inputFile.current.click()
                                                        }}
                                                        className={`ml-5 py-2 px-3 border border-gray-300 rounded-md text-sm leading-4 font-medium transition-colors ${canChange ? "bg-white text-gray-700 hover:bg-gray-50" : "bg-gray-50 text-gray-300"}`}
                                                    >
                                                        Change
                                                    </button>
                                                </div>
                                            </div>

                                            <div className="col-span-3 sm:col-span-2">
                                                <label htmlFor="name"
                                                       className="block text-sm font-medium text-gray-700">
                                                    Full Name
                                                </label>

                                                <input
                                                    required
                                                    ref={name}
                                                    onChange={() => {
                                                        setCanSave(name.current.value !== user.name || biography.current.value !== user.biography);
                                                    }}
                                                    type="text"
                                                    name="name"
                                                    id="name"
                                                    defaultValue={user.name}
                                                    className="mt-2 focus:ring-indigo-500 transition-colors focus:border-indigo-500 flex-1 block w-full rounded-md sm:text-sm border-gray-300"
                                                />
                                            </div>

                                            <div className="col-span-3 sm:col-span-2">
                                                <label htmlFor="email"
                                                       className="block text-sm font-medium text-gray-700">
                                                    Email
                                                </label>

                                                <input
                                                    disabled
                                                    type="email"
                                                    name="email"
                                                    id="email"
                                                    className="mt-2 focus:ring-indigo-500 transition-colors focus:border-indigo-500 flex-1 block w-full rounded-md sm:text-sm border-gray-300"
                                                    placeholder={user.email}
                                                />
                                            </div>

                                            <div className="col-span-3 sm:col-span-2">
                                                <div className="flex items-center w-full justify-between">
                                                    <label htmlFor="biography"
                                                           className="block text-sm font-medium text-gray-700">
                                                        Biography
                                                    </label>

                                                    <p className={`text-right font-medium transition-colors ${getBiographyColor()}`}>
                                                        {biographyLength}
                                                    </p>
                                                </div>

                                                <textarea
                                                    name="biography"
                                                    ref={biography}
                                                    id="biography"
                                                    maxLength={300}
                                                    rows={6}
                                                    onChange={() => {
                                                        setBiographyLength(biography.current.value.length)

                                                        setCanSave(name.current.value !== user.name || biography.current.value !== user.biography);
                                                    }}
                                                    className="mt-2 focus:ring-indigo-500 transition-colors focus:border-indigo-500 flex-1 block w-full rounded-md sm:text-sm border-gray-300 resize-none"
                                                    defaultValue={user.biography}
                                                />
                                            </div>

                                            {/*<div className="col-span-3 sm:col-span-2">*/}
                                            {/*    <label htmlFor="role"*/}
                                            {/*           className="block text-sm font-medium text-gray-700">*/}
                                            {/*        Role*/}
                                            {/*    </label>*/}

                                            {/*    <select*/}
                                            {/*        disabled*/}
                                            {/*        name="role"*/}
                                            {/*        id="role"*/}
                                            {/*        className="mt-2 focus:ring-indigo-500 transition-colors focus:border-indigo-500 pr-10 py-2 pl-3 flex-1 block w-full rounded-md sm:text-sm border-gray-300"*/}
                                            {/*        defaultValue="Head Coach" // default value olarak kendi rolü gelecek*/}
                                            {/*    >*/}
                                            {/*        <option>Head Coach</option>*/}
                                            {/*        <option>Assistant Coach</option>*/}
                                            {/*        <option>Analyst</option>*/}
                                            {/*        <option>Team Manager</option>*/}
                                            {/*        <option>Player</option>*/}
                                            {/*        <option>Player Agent</option>*/}
                                            {/*        <option>E-Sports Fan</option>*/}
                                            {/*    </select>*/}
                                            {/*</div>*/}

                                            {/*<div className="col-span-3 sm:col-span-2">*/}
                                            {/*    <label htmlFor="team"*/}
                                            {/*           className="block text-sm font-medium text-gray-700">*/}
                                            {/*        Team Name*/}
                                            {/*    </label>*/}

                                            {/*    <input*/}
                                            {/*        required*/}
                                            {/*        disabled*/}
                                            {/*        type="text"*/}
                                            {/*        name="team"*/}
                                            {/*        id="team"*/}
                                            {/*        className="mt-2 focus:ring-indigo-500 transition-colors focus:border-indigo-500 flex-1 block w-full rounded-md sm:text-sm border-gray-300"*/}
                                            {/*        placeholder="Free Agent"*/}
                                            {/*    />*/}
                                            {/*</div>*/}
                                        </div>

                                        <div className="col-span-3 sm:col-span-2 sm:pb-0">
                                            <div className="flex justify-end">
                                                <Link
                                                    to="/"
                                                    type="button"
                                                    className="py-2 px-4 flex items-center justify-center border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 hover:bg-gray-50"
                                                >
                                                    Cancel
                                                </Link>

                                                <button
                                                    disabled={!canSave}
                                                    type="submit"
                                                    className={`ml-3 inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium transition-colors rounded-md ${canSave ? "text-white bg-primary hover:bg-indigo-600" : "bg-gray-100 text-gray-400"}`}
                                                >
                                                    Save Changes
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            )}

            {type === 1 && (
                <div
                    className="space-y-4 sm:mt-8 sm:space-y-0 sm:grid sm:grid-cols-2 sm:gap-6 lg:max-w-4xl lg:mx-auto xl:max-w-none xl:mx-0 xl:grid-cols-4">
                    {tiers.map((tier) => (
                        <div key={tier.name}
                             className="border border-gray-200 rounded-lg shadow-sm divide-y divide-gray-200">
                            <div className="p-6">
                                <h2 className="text-lg leading-6 font-medium text-gray-900">{tier.name}</h2>
                                <p className="mt-4 text-sm text-gray-500">{tier.description}</p>
                                <p className="mt-8">
                                    <span
                                        className="text-4xl font-extrabold text-primary">{tier.price === 0 ? "Free" : `$${tier.price}`}</span>{' '}
                                    <span className="text-base font-medium text-gray-500">/mo</span>
                                </p>
                                <a
                                    href={tier.href}
                                    className="mt-8 block w-full bg-primary border border-transparent rounded-md py-2 text-sm font-semibold text-white text-center transition-colors hover:bg-indigo-600"
                                >
                                    {tier.price === 0 ? "Current Plan" : `Buy ${tier.name}`}
                                </a>
                            </div>
                            <div className="pt-6 pb-8 px-6">
                                <h3 className="text-xs font-medium text-gray-900 tracking-wide uppercase">What's
                                    included</h3>
                                <ul role="list" className="mt-6 space-y-4">
                                    {tier.features.map((feature) => (
                                        <li key={feature} className="flex space-x-3">
                                            <CheckIcon className="flex-shrink-0 h-5 w-5 text-green-500"
                                                       aria-hidden="true"/>
                                            <span className="text-sm text-gray-500">{feature}</span>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                    ))}
                </div>
            )}

            {type === 2 && (
                <fieldset className="space-y-5">
                    <legend className="sr-only">Preferences</legend>
                    <div className="relative flex items-start">
                        <div className="flex items-center h-5">
                            <input
                                id="scrim-offers"
                                aria-describedby="scrim-offers-description"
                                name="scrim-offers"
                                type="checkbox"
                                className="focus:ring-0 transition-colors h-4 w-4 text-indigo-600 border-gray-300 rounded"
                            />
                        </div>
                        <div className="ml-3 text-sm">
                            <label htmlFor="scrim-offers" className="font-medium text-gray-700">
                                Scrim Offers
                            </label>
                            <p id="scrim-offers-description" className="text-gray-500">
                                Get notified when someone makes an offer to your scrim request.
                            </p>
                        </div>
                    </div>
                    <div className="relative flex items-start">
                        <div className="flex items-center h-5">
                            <input
                                id="scrim-requests"
                                aria-describedby="scrim-requests-description"
                                name="scrim-requests"
                                type="checkbox"
                                className="focus:ring-0 transition-colors h-4 w-4 text-indigo-600 border-gray-300 rounded"
                            />
                        </div>
                        <div className="ml-3 text-sm">
                            <label htmlFor="scrim-requests" className="font-medium text-gray-700">
                                Scrim Approvals/Rejections
                            </label>
                            <p id="scrim-requests-description" className="text-gray-500">
                                Get notified when your scrim application gets rejected or approved by the opponent team.
                            </p>
                        </div>
                    </div>
                    <div className="relative flex items-start">
                        <div className="flex items-center h-5">
                            <input
                                id="scrim-cancellation"
                                aria-describedby="scrim-cancellation-description"
                                name="scrim-cancellation"
                                type="checkbox"
                                className="focus:ring-0 transition-colors h-4 w-4 text-indigo-600 border-gray-300 rounded"
                            />
                        </div>
                        <div className="ml-3 text-sm">
                            <label htmlFor="scrim-cancellation" className="font-medium text-gray-700">
                                Scrim Cancellations
                            </label>
                            <p id="scrim-cancellation-description" className="text-gray-500">
                                Get notified when a scrim gets cancelled.
                            </p>
                        </div>
                    </div>
                    <div className="relative flex items-start">
                        <div className="flex items-center h-5">
                            <input
                                id="report-notifications"
                                aria-describedby="report-notifications-description"
                                name="report-notifications"
                                type="checkbox"
                                className="focus:ring-0 transition-colors h-4 w-4 text-indigo-600 border-gray-300 rounded"
                            />
                        </div>
                        <div className="ml-3 text-sm">
                            <label htmlFor="report-notifications" className="font-medium text-gray-700">
                                Report Notifications
                            </label>
                            <p id="report-notifications-description" className="text-gray-500">
                                Get notified when your report is ready.
                            </p>
                        </div>
                    </div>
                    <div className="relative flex items-start">
                        <div className="flex items-center h-5">
                            <input
                                id="email-notifications"
                                aria-describedby="email-notifications-description"
                                name="email-notifications"
                                type="checkbox"
                                className="focus:ring-0 transition-colors h-4 w-4 text-indigo-600 border-gray-300 rounded"
                            />
                        </div>
                        <div className="ml-3 text-sm">
                            <label htmlFor="email-notifications" className="font-medium text-gray-700">
                                Email Notifications
                            </label>
                            <p id="email-notifications-description" className="text-gray-500">
                                Get notified when something happens via email.
                            </p>
                        </div>
                    </div>
                </fieldset>
            )}
        </div>
    )
}
